export default "__VITE_ASSET__gDBoHE3X__"